// src/firebase.js
import { initializeApp } from "firebase/app";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  disableNetwork,
  enableNetwork,
} from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFunctions} from "firebase/functions";
import { getMessaging, isSupported } from "firebase/messaging";
import { getStorage } from "firebase/storage";



// ⚠️ Reemplazá estos valores con los tuyos
const firebaseConfig = {
  apiKey: "AIzaSyD2lYmJzZBPydRCUXP2nyzGQkzoXs0dJi4",
  authDomain: "stock-urualum.firebaseapp.com",
  projectId: "stock-urualum",
  storageBucket: "stock-urualum.firebasestorage.app",
  messagingSenderId: "539303926650",
  appId: "1:539303926650:web:0e183219d06270652b14c3"
};
// Inicializa Firebase
const app = initializeApp(firebaseConfig);
console.log("[firebase.js] init projectId:", app.options.projectId, "app name:", app.name);

// Helper: obtener instancia de Messaging sólo si el navegador lo soporta
export const messagingPromise = (async () => {
  const supported = await isSupported();
  if (!supported) {
    console.log("[firebase.js] FCM no soportado en este navegador");
    return null;
  }
  try {
    const messaging = getMessaging(app);
    console.log("[firebase.js] Messaging inicializado");
    return messaging;
  } catch (err) {
    console.error("[firebase.js] Error inicializando messaging", err);
    return null;
  }
})();



// Exportá la instancia de Firestore.
// Usamos initializeFirestore (en vez de getFirestore) para activar la CACHÉ
// PERSISTENTE en disco (IndexedDB). Con esto, al reabrir la app o cambiar de
// pantalla los datos aparecen al instante desde la caché local y se revalidan
// de fondo contra el servidor, en vez de re-leer todo por internet cada vez.
// persistentMultipleTabManager coordina la caché cuando hay varias pestañas
// abiertas (en el celular/webview hay una sola, pero no molesta).
// IMPORTANTE: initializeFirestore debe llamarse una sola vez y antes de
// cualquier getFirestore(app); por eso este archivo es el único que inicializa
// Firestore y el resto (incluido utils/firebase.js) re-exporta este `db`.
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
  // Auto-detecta si la red/proxy rompe el streaming WebChannel y cae a long-polling.
  // Es el workaround estandar para "los listeners no actualizan en vivo" en ciertas redes.
  experimentalAutoDetectLongPolling: true,
});
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
// NUEVO: exportar Functions (ajustá la región si usás otra)
export const functions = getFunctions(app, "us-central1");
export const storage = getStorage(app);

// Cuando la app vuelve de segundo plano (PWA suspendida), los listeners de
// Firestore pueden "reanudarse" mostrando el último snapshot en memoria,
// que puede haber quedado desactualizado mientras la app estaba oculta.
// Forzamos un corte/reconexión para que todos los onSnapshot activos
// resincronicen desde el servidor.
let reconnecting = false;
function resyncFirestore() {
  // Solo si la pantalla esta visible y no hay una reconexion en curso.
  if (reconnecting || document.visibilityState !== "visible") return;
  reconnecting = true;
  disableNetwork(db)
    .then(() => enableNetwork(db))
    .catch((err) => console.error("[firebase.js] error reconectando Firestore:", err))
    .finally(() => { reconnecting = false; });
}
// Resincronizar en cada oportunidad de "volver al frente" o recuperar red, para
// que los onSnapshot vuelvan a vivo sin que el usuario tenga que recargar.
document.addEventListener("visibilitychange", resyncFirestore);
window.addEventListener("focus", resyncFirestore);
window.addEventListener("online", resyncFirestore);
window.addEventListener("pageshow", resyncFirestore);
// Latido: aunque no se dispare ningun evento (conexion suspendida en silencio),
// revalida contra el servidor cada 60s mientras la pantalla esta visible. Acota la
// ranciedad maxima a ~1 min en el peor caso. Es barato: si los datos no cambiaron,
// los listeners no re-emiten.
setInterval(resyncFirestore, 60000);

